import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=8636f74c&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8636f74c')) {
      api.createRecord('8636f74c', component.options)
    } else {
      api.reload('8636f74c', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=8636f74c&", function () {
      api.rerender('8636f74c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hL6y5aYIk7wu/JS/comp/stardisplay.vue"
export default component.exports